import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { CategoryEnrichmentProfile } from "../../recommendation.types";
import { requestGetEnrichmentProfiles } from "./getEnrichmentProfiles.request";

const useEnrichmentProfiles = (
  options?: QueryOptions<CategoryEnrichmentProfile[], ApiServiceError<ApiError>>
) => {
  const { data: profiles, ...rest } = useQuery({
    queryKey: ["recommendation", "enrichment", "profiles"],
    queryFn: requestGetEnrichmentProfiles,
    onError: toastServerError,
    ...options
  });

  return { profiles: profiles ?? [], ...rest };
};

export default useEnrichmentProfiles;
